import PlusFilledIcon from './PlusFilledIcon';

export default PlusFilledIcon;
